var version = '0.4.1';
export { version };
//# sourceMappingURL=version.js.map